function openMenu() {
    document.getElementById('menu-overlay').classList.remove('opacity-0', 'pointer-events-none');
    document.getElementById('mobile-menu').classList.remove('-translate-x-full');
    document.body.classList.add('overflow-hidden');
}
function closeMenu() {
    document.getElementById('menu-overlay').classList.add('opacity-0', 'pointer-events-none');
    document.getElementById('mobile-menu').classList.add('-translate-x-full');
    document.body.classList.remove('overflow-hidden');
}
function toggleMobileSubmenu(btn) {
    var wrapper = btn.closest('div').parentElement;
    var submenu = wrapper.querySelector('.mobile-submenu');
    if (!submenu) return;
    var isOpen = !submenu.classList.contains('hidden');
    submenu.classList.toggle('hidden');
    var icon = btn.querySelector('.mobile-submenu-icon');
    if (icon) { icon.style.transform = isOpen ? '' : 'rotate(180deg)'; }
}

var COOKIE_CONSENT_NAME = 'ak_atelier_cookie_consent';

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
}

function getCookie(name) {
    var nameEQ = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
        var c = parts[i];
        while (c.charAt(0) === ' ') { c = c.substring(1, c.length); }
        if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length); }
    }
    return null;
}

function initCookieConsent() {
    var banner = document.getElementById('cookie-consent-banner');
    if (!banner) return;
    if (!getCookie(COOKIE_CONSENT_NAME)) {
        banner.classList.remove('hidden');
    }
}

function acceptCookies() {
    setCookie(COOKIE_CONSENT_NAME, 'accepted', 365);
    var banner = document.getElementById('cookie-consent-banner');
    if (banner) { banner.classList.add('hidden'); }
}

function rejectCookies() {
    setCookie(COOKIE_CONSENT_NAME, 'rejected', 365);
    var banner = document.getElementById('cookie-consent-banner');
    if (banner) { banner.classList.add('hidden'); }
}

function formatMoney(cents) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = MONEY_FORMAT.match(placeholderRegex);

    function withDelimiters(number, precision, thousands, decimal) {
        precision = (typeof precision === 'undefined') ? 2 : precision;
        thousands = (typeof thousands === 'undefined') ? ',' : thousands;
        decimal = (typeof decimal === 'undefined') ? '.' : decimal;
        if (isNaN(number) || number == null) { return 0; }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollarsPart + centsPart;
    }

    var value = withDelimiters(cents, 2);
    if (match) {
        switch (match[1]) {
            case 'amount': value = withDelimiters(cents, 2); break;
            case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
            case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
            case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
            case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
            case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        }
        return MONEY_FORMAT.replace(placeholderRegex, value);
    }
    return value;
}

var COLOR_HEX_MAP = {
    'fekete': '#1c1917', 'fehér': '#ffffff', 'feher': '#ffffff',
    'sötétkék': '#1e3a5f', 'sotetkek': '#1e3a5f', 'kék': '#2563eb', 'kek': '#2563eb',
    'világoskék': '#7dd3fc', 'vilagoskek': '#7dd3fc',
    'piros': '#dc2626', 'vörös': '#dc2626', 'voros': '#dc2626',
    'bordó': '#7f1d1d', 'bordo': '#7f1d1d',
    'rózsaszín': '#f9a8d4', 'rozsaszin': '#f9a8d4',
    'sárga': '#eab308', 'sarga': '#eab308',
    'zöld': '#16a34a', 'zold': '#16a34a', 'khaki': '#8a8a5c',
    'barna': '#78350f', 'bézs': '#e8dcc8', 'bezs': '#e8dcc8', 'drapp': '#d9cba8',
    'szürke': '#9ca3af', 'szurke': '#9ca3af',
    'lila': '#9333ea', 'narancs': '#ea580c', 'narancssárga': '#ea580c', 'narancssarga': '#ea580c',
    'ezüst': '#c0c0c0', 'ezust': '#c0c0c0', 'arany': '#C6A15B',
    'türkiz': '#14b8a6', 'turkiz': '#14b8a6', 'menta': '#6ee7b7', 'korall': '#fb7185',
    'black': '#1c1917', 'white': '#ffffff', 'navy': '#1e3a5f', 'blue': '#2563eb',
    'light-blue': '#7dd3fc', 'royal-blue': '#3b5bdb', 'red': '#dc2626', 'burgundy': '#7f1d1d',
    'pink': '#f9a8d4', 'powder-pink': '#f3d1d8', 'fuchsia': '#d946ef', 'yellow': '#eab308',
    'green': '#16a34a', 'lime-green': '#84cc16', 'brown': '#78350f', 'beige': '#e8dcc8',
    'nude': '#e3bfa8', 'grey': '#9ca3af', 'gray': '#9ca3af', 'purple': '#9333ea',
    'orange': '#ea580c', 'silver': '#c0c0c0', 'gold': '#C6A15B',
    'teal': '#14b8a6', 'mint': '#6ee7b7', 'corall': '#fb7185', 'coral': '#fb7185',
    'terracotta': '#c2593f'
};

function colorToHex(name) {
    var key = (name || '').toLowerCase().trim();
    return COLOR_HEX_MAP[key] || '#d6d3d1';
}

var COLOR_HU_NAME = {
    'fekete': 'Fekete', 'black': 'Fekete',
    'fehér': 'Fehér', 'feher': 'Fehér', 'white': 'Fehér',
    'sötétkék': 'Sötétkék', 'sotetkek': 'Sötétkék', 'navy': 'Sötétkék',
    'kék': 'Kék', 'kek': 'Kék', 'blue': 'Kék',
    'világoskék': 'Világoskék', 'vilagoskek': 'Világoskék', 'light-blue': 'Világoskék',
    'royal-blue': 'Királykék',
    'piros': 'Piros', 'vörös': 'Vörös', 'voros': 'Vörös', 'red': 'Piros',
    'bordó': 'Bordó', 'bordo': 'Bordó', 'burgundy': 'Bordó',
    'rózsaszín': 'Rózsaszín', 'rozsaszin': 'Rózsaszín', 'pink': 'Rózsaszín',
    'powder-pink': 'Púderrózsaszín',
    'fuchsia': 'Pink',
    'sárga': 'Sárga', 'sarga': 'Sárga', 'yellow': 'Sárga',
    'zöld': 'Zöld', 'zold': 'Zöld', 'green': 'Zöld',
    'khaki': 'Khaki', 'lime-green': 'Limezöld',
    'barna': 'Barna', 'brown': 'Barna',
    'bézs': 'Bézs', 'bezs': 'Bézs', 'beige': 'Bézs', 'drapp': 'Drapp', 'nude': 'Nude',
    'szürke': 'Szürke', 'szurke': 'Szürke', 'grey': 'Szürke', 'gray': 'Szürke',
    'lila': 'Lila', 'purple': 'Lila',
    'narancs': 'Narancs', 'narancssárga': 'Narancssárga', 'narancssarga': 'Narancssárga', 'orange': 'Narancs',
    'ezüst': 'Ezüst', 'ezust': 'Ezüst', 'silver': 'Ezüst', 'arany': 'Arany', 'gold': 'Arany',
    'türkiz': 'Türkiz', 'turkiz': 'Türkiz', 'teal': 'Türkiz', 'menta': 'Menta', 'mint': 'Menta',
    'korall': 'Korall', 'corall': 'Korall', 'coral': 'Korall', 'terracotta': 'Terrakotta'
};

function colorDisplayName(name) {
    var key = (name || '').toLowerCase().trim();
    if (COLOR_HU_NAME[key]) return COLOR_HU_NAME[key];
    var raw = (name || '').trim();
    if (!raw) return raw;
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}

var __cardImgObserver = null;
function getCardImgObserver() {
    if (__cardImgObserver) return __cardImgObserver;
    if (!('IntersectionObserver' in window)) return null;
    __cardImgObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var img = entry.target;
            if (img.dataset.defaultImg && !img.getAttribute('src')) {
                img.src = img.dataset.defaultImg;
            }
            __cardImgObserver.unobserve(img);
        });
    }, { rootMargin: '1500px 0px 1500px 0px' });
    return __cardImgObserver;
}

function initProductCard(card) {
    card.querySelectorAll('.product-color-swatch').forEach(function (sw) {
        sw.style.backgroundColor = colorToHex(sw.dataset.colorValue);
        var label = colorDisplayName(sw.dataset.colorValue);
        sw.setAttribute('aria-label', label);
        sw.setAttribute('title', label);
    });
    var cardImg = card.querySelector('.product-card-img[data-default-img]');
    if (cardImg && !cardImg.getAttribute('src')) {
        var observer = getCardImgObserver();
        if (observer) { observer.observe(cardImg); } else { cardImg.src = cardImg.dataset.defaultImg; }
    }
}

function getCardVariants(card) {
    try { return JSON.parse(card.dataset.variants || '[]'); } catch (e) { return []; }
}

function resolveCardVariant(card, colorVal, sizeVal) {
    var variants = getCardVariants(card);
    var colorIdx = parseInt(card.dataset.colorIdx, 10);
    var sizeIdx = parseInt(card.dataset.sizeIdx, 10);
    var colorKey = colorIdx > -1 ? 'option' + (colorIdx + 1) : null;
    var sizeKey = sizeIdx > -1 ? 'option' + (sizeIdx + 1) : null;

    var exact = variants.filter(function (v) {
        var okColor = !colorKey || colorVal == null || v[colorKey] === colorVal;
        var okSize = !sizeKey || sizeVal == null || v[sizeKey] === sizeVal;
        return okColor && okSize;
    });
    var exactAvailable = exact.filter(function (v) { return v.available; });
    if (exactAvailable[0]) return exactAvailable[0];
    if (exact[0]) return exact[0];

    // Requested size doesn't exist for this color — keep the color, pick any other size for it.
    var colorOnly = variants.filter(function (v) {
        return !colorKey || colorVal == null || v[colorKey] === colorVal;
    });
    var colorOnlyAvailable = colorOnly.filter(function (v) { return v.available; });
    return colorOnlyAvailable[0] || colorOnly[0] || variants[0];
}

function applyCardVariant(card, variant) {
    if (!variant) return;
    card.dataset.selectedVariantId = variant.id;
    var colorIdx = parseInt(card.dataset.colorIdx, 10);
    var sizeIdx = parseInt(card.dataset.sizeIdx, 10);
    var colorKey = colorIdx > -1 ? 'option' + (colorIdx + 1) : null;
    var sizeKey = sizeIdx > -1 ? 'option' + (sizeIdx + 1) : null;
    var selectedColor = colorKey ? variant[colorKey] : null;
    var selectedSize = sizeKey ? variant[sizeKey] : null;
    var variants = getCardVariants(card);

    card.querySelectorAll('.product-color-swatch').forEach(function (sw) {
        var isActive = sw.dataset.colorValue === selectedColor;
        sw.dataset.active = isActive ? 'true' : 'false';
        sw.classList.remove('ring-1', 'ring-2', 'ring-stone-200', 'ring-stone-900', 'ring-offset-2');
        sw.classList.add(isActive ? 'ring-2' : 'ring-1', isActive ? 'ring-stone-900' : 'ring-stone-200');
        if (isActive) { sw.classList.add('ring-offset-2'); }
    });

    card.querySelectorAll('.product-size-btn').forEach(function (btn) {
        var sizeVal = btn.dataset.sizeValue;
        var isActive = sizeVal === selectedSize;
        btn.dataset.active = isActive ? 'true' : 'false';
        btn.classList.toggle('border-stone-900', isActive);
        btn.classList.toggle('text-stone-900', isActive);
        btn.classList.toggle('border-stone-200', !isActive);
        btn.classList.toggle('text-stone-500', !isActive);
        var hasAvailable = variants.some(function (v) {
            var okColor = !colorKey || !selectedColor || v[colorKey] === selectedColor;
            return okColor && v[sizeKey] === sizeVal && v.available;
        });
        btn.disabled = !hasAvailable;
        btn.classList.toggle('opacity-40', !hasAvailable);
        btn.classList.toggle('cursor-not-allowed', !hasAvailable);
        btn.classList.toggle('line-through', !hasAvailable);
    });

    var addBtn = card.querySelector('.product-add-btn');
    if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.classList.toggle('opacity-50', !variant.available);
        addBtn.classList.toggle('cursor-not-allowed', !variant.available);
        var label = addBtn.querySelector('.product-add-label');
        if (label) { label.textContent = variant.available ? 'Kosárba' : 'Elfogyott'; }
    }

    var cardPriceEl = card.querySelector('.card-price');
    if (cardPriceEl) {
        cardPriceEl.textContent = formatMoney(variant.price);
        var cardHasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        cardPriceEl.classList.toggle('text-[#C6A15B]', cardHasDiscount);
        cardPriceEl.classList.toggle('text-stone-900', !cardHasDiscount);
        var cardCompareRow = card.querySelector('.card-compare-row');
        if (cardCompareRow) {
            cardCompareRow.classList.toggle('hidden', !cardHasDiscount);
            if (cardHasDiscount) {
                var cardComparePriceEl = card.querySelector('.card-compare-price');
                if (cardComparePriceEl) { cardComparePriceEl.textContent = formatMoney(variant.compare_at_price); }
                var cardDiscountBadge = card.querySelector('.card-discount-badge');
                if (cardDiscountBadge) {
                    var cardPct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
                    cardDiscountBadge.textContent = '-' + cardPct + '%';
                }
            }
        }
    }

    var img = card.querySelector('.product-card-img');
    if (img) {
        if (variant.featured_image && variant.featured_image.src) {
            var w = card.dataset.imgWidth || '800';
            var src = variant.featured_image.src;
            var sep = src.indexOf('?') > -1 ? '&' : '?';
            img.src = src + sep + 'width=' + w;
        } else if (img.dataset.defaultImg) {
            img.src = img.dataset.defaultImg;
        }
    }
}

function selectCardColor(btn) {
    var card = btn.closest('.product-card');
    if (!card) return;
    var sizeIdx = parseInt(card.dataset.sizeIdx, 10);
    var activeSize = card.querySelector('.product-size-btn[data-active="true"]');
    var sizeVal = sizeIdx > -1 && activeSize ? activeSize.dataset.sizeValue : null;
    applyCardVariant(card, resolveCardVariant(card, btn.dataset.colorValue, sizeVal));
}

function selectCardSize(btn) {
    if (btn.disabled) return;
    var card = btn.closest('.product-card');
    if (!card) return;
    var colorIdx = parseInt(card.dataset.colorIdx, 10);
    var activeSwatch = card.querySelector('.product-color-swatch[data-active="true"]');
    var colorVal = colorIdx > -1 && activeSwatch ? activeSwatch.dataset.colorValue : null;
    applyCardVariant(card, resolveCardVariant(card, colorVal, btn.dataset.sizeValue));
}

function addProductToCart(btn) {
    if (btn.disabled) return;
    var card = btn.closest('.product-card');
    if (!card) return;
    var variantId = card.dataset.selectedVariantId;
    if (!variantId) return;
    addToCart(variantId, 1, btn);
}

function addToCart(variantId, quantity, triggerBtn) {
    if (triggerBtn) { triggerBtn.disabled = true; }
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
        .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
            if (!result.ok) {
                alert(result.data.description || result.data.message || 'Nem sikerült a kosárba helyezés.');
                return;
            }
            return refreshCart().then(openCart);
        })
        .catch(function () {
            alert('Hálózati hiba történt, próbáld újra.');
        })
        .then(function () {
            if (triggerBtn) { triggerBtn.disabled = false; }
        });
}

function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            renderCart(cart);
            return cart;
        });
}

function changeLineQty(key, quantity) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshCart(); });
}

function removeLine(key) {
    changeLineQty(key, 0);
}

function openCart() {
    document.getElementById('cart-overlay').classList.remove('opacity-0', 'pointer-events-none');
    document.getElementById('cart-drawer').classList.remove('translate-x-full');
    document.body.classList.add('overflow-hidden');
}

function closeCart() {
    document.getElementById('cart-overlay').classList.add('opacity-0', 'pointer-events-none');
    document.getElementById('cart-drawer').classList.add('translate-x-full');
    document.body.classList.remove('overflow-hidden');
}

function emptyStateHtml() {
    return '<div class="h-full flex flex-col items-center justify-center text-center px-8 py-20">' +
        '<h3 class="text-lg font-serif font-medium text-stone-900 mb-3">A kosarad üres</h3>' +
        '<p class="text-sm text-stone-500 font-light mb-6">Van már fiókod? <a href="#" class="underline hover:text-[#C6A15B] transition-colors">Jelentkezz be</a> a gyorsabb fizetéshez.</p>' +
        '<button type="button" onclick="closeCart()" class="px-8 py-3.5 bg-stone-900 text-white text-xs normal-case tracking-widest font-medium hover:bg-[#C6A15B] transition-colors">Tovább Vásárolok</button>' +
        '</div>';
}

function lineItemHtml(item) {
    var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    return '<div class="flex gap-4 px-6 py-5 border-b border-stone-100">' +
        '<div class="w-20 h-24 bg-stone-100 overflow-hidden shrink-0">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '" class="w-full h-full object-cover">' +
        '</div>' +
        '<div class="flex-1 min-w-0">' +
        '<div class="flex items-start justify-between gap-2">' +
        '<div>' +
        '<h4 class="text-sm font-medium text-stone-900 normal-case tracking-wide">' + item.product_title + '</h4>' +
        (variantLabel ? '<p class="text-xs text-stone-400 normal-case tracking-widest mt-1">' + variantLabel + '</p>' : '') +
        '</div>' +
        '<span class="text-sm font-medium text-stone-900 whitespace-nowrap">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<div class="flex items-center justify-between mt-3">' +
        '<div class="flex items-center border border-stone-200">' +
        '<button type="button" onclick="changeLineQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" class="w-7 h-7 flex items-center justify-center hover:text-[#C6A15B] transition-colors">−</button>' +
        '<span class="w-8 text-center text-sm">' + item.quantity + '</span>' +
        '<button type="button" onclick="changeLineQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" class="w-7 h-7 flex items-center justify-center hover:text-[#C6A15B] transition-colors">+</button>' +
        '</div>' +
        '<button type="button" onclick="removeLine(\'' + item.key + '\')" aria-label="Törlés" class="text-stone-400 hover:text-[#C6A15B] transition-colors">' +
        '<iconify-icon icon="solar:trash-bin-minimalistic-linear" width="18"></iconify-icon>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>';
}

function getRecommendationsMap() {
    try {
        var el = document.getElementById('recommendations-map');
        return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
        return {};
    }
}

function renderRecommended(cart) {
    var container = document.getElementById('cart-recommended');
    var templateRoot = document.getElementById('recommended-templates');
    if (!container || !templateRoot) return;
    var cartProductIds = (cart.items || []).map(function (i) { return String(i.product_id); });
    var allCards = Array.prototype.slice.call(templateRoot.content.querySelectorAll('.product-card'));

    var map = getRecommendationsMap();
    var curatedIds = [];
    cartProductIds.forEach(function (pid) {
        (map[pid] || []).forEach(function (rid) {
            var ridStr = String(rid);
            if (cartProductIds.indexOf(ridStr) === -1 && curatedIds.indexOf(ridStr) === -1) {
                curatedIds.push(ridStr);
            }
        });
    });

    var candidates;
    if (curatedIds.length > 0) {
        candidates = curatedIds
            .map(function (rid) { return allCards.filter(function (el) { return el.dataset.productId === rid; })[0]; })
            .filter(Boolean)
            .slice(0, 4);
    } else {
        candidates = allCards
            .filter(function (el) { return cartProductIds.indexOf(el.dataset.productId) === -1; })
            .slice(0, 2);
    }
    container.innerHTML = '';
    candidates.forEach(function (el) {
        var clone = el.cloneNode(true);
        container.appendChild(clone);
        initProductCard(clone);
    });
}

function renderCart(cart) {
    var count = cart.item_count;
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });

    var body = document.getElementById('cart-body');
    var footer = document.getElementById('cart-footer');

    if (!cart.items || cart.items.length === 0) {
        footer.classList.add('hidden');
        body.innerHTML = emptyStateHtml();
        return;
    }

    footer.classList.remove('hidden');
    document.getElementById('cart-subtotal').textContent = formatMoney(cart.total_price);

    var itemsHtml = cart.items.map(lineItemHtml).join('');
    var recommendedHtml = '<div class="px-6 py-6">' +
        '<h3 class="text-xs normal-case tracking-widest text-stone-500 font-medium mb-4">Ezt Is Szeretheted</h3>' +
        '<div id="cart-recommended" class="grid grid-cols-2 gap-4"></div>' +
        '</div>';

    body.innerHTML = itemsHtml + recommendedHtml;
    renderRecommended(cart);
}

var WISHLIST_KEY = 'ak-atelier-wishlist';

function getWishlist() {
    try {
        var raw = localStorage.getItem(WISHLIST_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        return [];
    }
}

function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
}

function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
}

function setWishlistButtonState(btn, isActive) {
    var icon = btn.querySelector('iconify-icon');
    if (icon) {
        icon.setAttribute('icon', isActive ? 'solar:heart-bold' : 'solar:heart-linear');
    }
    btn.classList.toggle('text-[#C6A15B]', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
}

function toggleWishlist(btn, productId) {
    var list = getWishlist();
    var idStr = String(productId);
    var idx = list.indexOf(idStr);
    var nowActive = idx === -1;
    if (nowActive) {
        list.push(idStr);
    } else {
        list.splice(idx, 1);
    }
    saveWishlist(list);
    document.querySelectorAll('.wishlist-btn[data-product-id="' + idStr + '"]').forEach(function (b) {
        setWishlistButtonState(b, nowActive);
    });
    if (typeof activeFilters !== 'undefined' && activeFilters.wishlistOnly) { applyFilters(); }
}

function initWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
        setWishlistButtonState(btn, isWishlisted(btn.dataset.productId));
    });
}

function initCategoryScrollHint(wrap) {
    var row = wrap.querySelector('.category-scroll-row');
    var leftHint = wrap.querySelector('.category-scroll-row-hint-left');
    var rightHint = wrap.querySelector('.category-scroll-row-hint-right');
    if (!row || !rightHint) return;
    function update() {
        var maxScroll = row.scrollWidth - row.clientWidth;
        if (maxScroll <= 4) {
            rightHint.style.opacity = '0';
            if (leftHint) { leftHint.style.opacity = '0'; }
            return;
        }
        var atStart = row.scrollLeft <= 4;
        var atEnd = row.scrollLeft >= maxScroll - 4;
        rightHint.style.opacity = atEnd ? '0' : '1';
        if (leftHint) { leftHint.style.opacity = atStart ? '0' : '1'; }
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
}
